// Billing settings (localStorage), mirroring Android's DataStore + BillingCurrency.
//   * currency: USD or MXN (each with a symbol + default human/AI hourly rates)
//   * hourly rate (human) and AI hourly rate — a single stored number each,
//     falling back to the current currency's default when unset (like Android's
//     hourlyRateFlow / aiHourlyRateFlow)
//   * AI invoicing toggle (default ON, like Android): when on, AI-tracked
//     sessions bill at the AI rate; when off, everything bills at the human rate.

const CURRENCY_KEY = "billing_currency";
const RATE_KEY = "billing_hourly_rate";
const AI_RATE_KEY = "billing_ai_hourly_rate";
const AI_INVOICE_KEY = "billing_ai_invoice_enabled";

// Matches Android's BillingCurrency enum exactly (code, symbol, defaults).
export const CURRENCIES = {
  USD: { code: "USD", symbol: "$", defaultHourlyRate: 10, defaultAiHourlyRate: 5 },
  MXN: { code: "MXN", symbol: "$", defaultHourlyRate: 200, defaultAiHourlyRate: 100 },
};
export const CURRENCY_CODES = Object.keys(CURRENCIES);
export const DEFAULT_CURRENCY = "USD";

export function getCurrency() {
  const c = localStorage.getItem(CURRENCY_KEY);
  return CURRENCIES[c] ? c : DEFAULT_CURRENCY;
}

export function setCurrency(code) {
  if (CURRENCIES[code]) localStorage.setItem(CURRENCY_KEY, code);
}

export function getCurrencyInfo() {
  return CURRENCIES[getCurrency()];
}

function readRate(key, fallback) {
  const n = parseFloat(localStorage.getItem(key));
  return Number.isFinite(n) && n >= 0 ? n : fallback;
}

export function getHourlyRate() {
  return readRate(RATE_KEY, getCurrencyInfo().defaultHourlyRate);
}
export function setHourlyRate(value) {
  const n = parseFloat(value);
  if (Number.isFinite(n) && n >= 0) localStorage.setItem(RATE_KEY, String(n));
}

export function getAiHourlyRate() {
  return readRate(AI_RATE_KEY, getCurrencyInfo().defaultAiHourlyRate);
}
export function setAiHourlyRate(value) {
  const n = parseFloat(value);
  if (Number.isFinite(n) && n >= 0) localStorage.setItem(AI_RATE_KEY, String(n));
}

export function isAiInvoiceEnabled() {
  const v = localStorage.getItem(AI_INVOICE_KEY);
  return v === null ? true : v === "true"; // default ON, like Android
}
export function setAiInvoiceEnabled(enabled) {
  localStorage.setItem(AI_INVOICE_KEY, enabled ? "true" : "false");
}
